// libs
import React, { memo } from "react";
import styled from "@emotion/styled";

// local components
import ImageLink from "shared/components/Header/DesktopHeader/components/Menu/components/ImageLink";

// defs
import { IMapOfString } from "global";
interface IBigImageProps {
    data: IMapOfString;
    position: number;
}

// styles
const Container = styled.div`
    margin: 0 0 0 auto;
`;

function BigImage({ data, position }: IBigImageProps) {
    return (
        <Container>
            {data.children.map((img, idx) => {
                const imgData = { ...img, position, isCuration: true };

                return <ImageLink data={imgData} key={idx} isBig />;
            })}
        </Container>
    );
}

export default memo(BigImage);
